import { defineMessages } from 'react-intl';

export default defineMessages({
  orderNav: {
    id: 'sidenav.orderNav',
    description: 'dashboard navlink',
    defaultMessage: 'Dashboard',
  },
  analyticsNav: {
    id: 'sidenav.analyticsNav',
    description: 'analytics navlink',
    defaultMessage: 'Analytics',
  },
  bmwWsBrand: {
    id: 'sidenav.bmwWsBrand',
    description: 'bmw webshop brand text',
    defaultMessage: 'BMW Webshop',
  },
  miniWsBrand: {
    id: 'sidenav.miniWsBrand',
    description: 'mini webshop brand text',
    defaultMessage: 'MINI Webshop',
  },
});
